
let customsearch = location.search.split('?');
if(customsearch.includes('selector=ROW')){
  localStorage.setItem('selector','true');
  document.querySelectorAll('.top-bar__redirects [data-trigger-dropdown] span:first-child')[0].innerHTML = "ROW";
  document.querySelectorAll('.top-bar__redirects [data-trigger-dropdown] span:first-child')[1].innerHTML = "ROW";
}else if(customsearch.includes('selector=false')){
  localStorage.setItem('selector','false');
}

if(localStorage.getItem('selector') == 'true'){
    document.querySelectorAll('.top-bar__redirects [data-trigger-dropdown] span:first-child')[0].innerHTML = "ROW";
    document.querySelectorAll('.top-bar__redirects [data-trigger-dropdown] span:first-child')[1].innerHTML = "ROW";
}


let locahref = window.location.href;
let locaPop = localStorage.getItem("popUp");
let setupTime = localStorage.getItem('popUpEndTime');
let setLocPop = document.querySelectorAll('.redirect-options > ul > li > a');
if(setupTime != null) {
  console.log(setupTime);
}
// (if someone want to clear after 8hrs simply change hours=8)
let hours = 720; //30 days(day*24(hrs/day))
let now = new Date().getTime();
let deleteTime = Number(setupTime) + hours*60*60*1000;

if (locahref.split('?popup=')[1] != null){
  if(locaPop == null) {
    localStorage.setItem("popUp", "false");
    localStorage.setItem("popUpEndTime", Number(locahref.split('?popup=')[1]));
    locaPop = "False";
  }
}

setLocPop.forEach((item) => {
  item.addEventListener('click', (em)=> {
    if(locaPop == null) {
    em.preventDefault();
      let time_click = new Date().getTime();
      let new_link = item.href.split('?popup=')[0];
      console.log('no effect')
      if (locahref.includes(new_link)) {
      window.location = new_link;
      } else {
        localStorage.setItem("popUpEndTime", time_click);
        localStorage.setItem("popUp", "false");
        window.location = new_link + "?popup=" + time_click
      }
    } else {
      if(now > deleteTime) {
        localStorage.removeItem("popUp");
        localStorage.removeItem("popUpEndTime");
        locaPop = null
      }
    }
  });
});


(() => {
  const TextWithColumnImagesSwiper = () => {
    let SwipersInit = () => {
      document.querySelectorAll('.text-columns-images-swiper:not(.swiper-initialized)').forEach(($section) => {
        let $sectionWrap = $section.closest('.section-wrap--text-columns-images');
        var swiper = new Swiper($section, {
          slidesPerView: 1.1,
          spaceBetween: 20,
          centeredSlides: true,
          centeredSlidesBounds: true,
          autoHeight: false,
          navigation: {
            nextEl: $sectionWrap.querySelector('.swiper-button-next'),
            prevEl: $sectionWrap.querySelector('.swiper-button-prev')
          },
          pagination: {
          },
          breakpoints: {
            768: {
              slidesPerView: 2.5,
            },
            1024: {
              slidesPerView: 3,
              spaceBetween: 25
            }
          }
        });      
      });  
    }

    SwipersInit();

    var shopify_events = ['shopify:section:deselect','shopify:section:unload'];
    shopify_events.forEach((event_type) => {
      document.addEventListener(event_type, SwipersInit);
    });    
  }

  const TextReadMoreLess = () => {
    document.querySelectorAll('[data-read_more_less="true"]').forEach(($section) => {
      if ($section.querySelectorAll('*:not(:empty)').length > 1) {
        $section.insertAdjacentHTML('beforeend', '<a href="#" data-read-more-toggle>Read More</a>');
      }

      $section.querySelectorAll('[data-read-more-toggle]').forEach(($readMoreToggle) => {
        $readMoreToggle.addEventListener('click', (e) => {
          e.preventDefault();
          let toggle = JSON.parse($section.dataset.read_more_less);
          $section.dataset.read_more_less = !toggle;
          $readMoreToggle.innerText = !toggle ? 'Read More' : 'Read Less';
        });
      });
    });
  }

  const ListReadMoreLess = () => {
    document.querySelectorAll('[data-list_more_less="true"]').forEach(($section) => {
      $section.insertAdjacentHTML('beforeend', '<a href="#" data-read-more-toggle>Show More</a>');
    
      $section.querySelectorAll('[data-read-more-toggle]').forEach(($readMoreToggle) => {
        $readMoreToggle.addEventListener('click', (e) => {
          e.preventDefault();
          let toggle = JSON.parse($section.dataset.list_more_less);
          $section.dataset.list_more_less = !toggle;
          $readMoreToggle.innerText = !toggle ? 'Show More' : 'Show Less';
        });
      });
    });
  }

  const ConvertStringToHTML = (str) => {
    let parser = new DOMParser();
    let doc = parser.parseFromString(str, 'text/html');
    return doc.body;
  }

  const OnElementLoad = (selector, callback) => {
    var loaded = false;
    var timer = setInterval(function() {
      let $elements = document.querySelectorAll(selector);
      if ($elements.length) {
        console.log(selector + ' loaded!');
        loaded = true;
      }

      if (loaded) {
        clearInterval(timer);
        callback($elements);
      }
    }, 100);
  }    

  let ToggleAfterpayWithSubscription = () => {
    let $section = document.querySelector('.product__details--product-page');
    if (!$section) return;
    
    let isOnetime = $section.querySelector('.skio-plan-picker') ? $section.querySelector('.skio-plan-picker input[type=radio]:checked').value == '' : true;
    let isSubscription = !isOnetime;

    let toggle = () => {
      $section.classList.toggle('hide-afterpay', isSubscription);
    }

    let $afterpay = $section.querySelector('afterpay-placement');
    if ($afterpay) {
      toggle();
    }
    else {
      OnElementLoad('afterpay-placement', toggle);
    }
  }

  const ProductVariantChange = () => {
    let current_variant;
    let UpdatePricePerServe = () => {
      document.querySelectorAll('.product_section .price_per_serve').forEach(($price_per_serve) => {
        let variant_price_per_serve = $price_per_serve.dataset.variantPricePerServe;
        let $content = ConvertStringToHTML($price_per_serve.dataset.content);
        $price_per_serve.innerHTML = $content.innerHTML.replaceAll('${per_serve}', variant_price_per_serve);
        $price_per_serve.classList.remove('hidden');
      });
    }

    let UpdateVariantPrices = ($form, variant) => {
      if (!variant) {
        console.error('No variant!', $form, variant);
        return;
      }

      let $section = $form.closest('.product__details--product-page');
      let isOnetime = $section.querySelector('.skio-plan-picker') ? $section.querySelector('.skio-plan-picker input[type=radio]:checked').value == '' : true;
      let isSubscription = !isOnetime;

      $form.closest('.product_section').querySelectorAll('.price_per_serve').forEach(($price_per_serve) => {
        let variants_price_per_serve = JSON.parse($price_per_serve.dataset.variants_price_per_serve);
        let per_serve = parseInt(variants_price_per_serve[variant.id]);
        let variant_price_per_serve = variant.price / per_serve;
        if (isSubscription) {
          setTimeout(() => {
            let $subscription_price = $section.querySelector('.skio-group-container--selected [skio-subscription-price]').textContent;
            variant_price_per_serve = parseFloat($subscription_price.replaceAll('$','')) * 100 / per_serve;
  
            let formatted_price = Shopify.formatMoney(variant_price_per_serve, PXUTheme.currency.money_format);
            $price_per_serve.dataset.variantPricePerServe = formatted_price;
            UpdatePricePerServe();  
          }, 0);
        }
        else {
          let formatted_price = Shopify.formatMoney(variant_price_per_serve, PXUTheme.currency.money_format);
          $price_per_serve.dataset.variantPricePerServe = formatted_price;
          UpdatePricePerServe();  
        }
      });

      ToggleAfterpayWithSubscription();
    }

    document.addEventListener('variant:change', (e) => {
      //console.log(e);
      if (!e.detail || !e.detail.variant || !e.detail.selector) return;

      let product = e.detail.selector.product;
      let variant = e.detail.variant;
      current_variant = variant;
      let $forms = document.querySelectorAll(`#product_form_${ product.id }`);
      $forms.forEach(($form) => {
        // Sync variantid selection across multiple forms within same section
        let $selectMain = $form.querySelector('select');
        $selectMain.value = variant.id;

        // Price per serving
        UpdateVariantPrices($form, variant);
      });
    });

    // with subscription or one-time selection update
    document.querySelectorAll('.skio-plan-picker').forEach(($sub_section) => {
      $sub_section.addEventListener('change', (e) => {
        let $section = e.currentTarget.closest('.product__details--product-page');
        let $forms = $section.querySelectorAll('.shopify-product-form');
        $forms.forEach(($form) => {
          UpdateVariantPrices($form, current_variant);
        });
      });
    });
  }

  const LocationPopup = async () => {
    const CURRENTSITE = window.PXUTheme.shop;
    const ALLOW_COUNTRIES = window.PXUTheme.allow_countries;

    const GetLocationIP = async () => {
      return fetch('/browsing_context_suggestions.json').then((res) => res.json());
    }

    let location_IP = await GetLocationIP();
    let location_Country = location_IP.detected_values.country.handle;
    let triggerOtherSite = ALLOW_COUNTRIES.indexOf(location_Country) == -1 && Shopify.shop == CURRENTSITE;

    const SESSION_KEY_CURRENT_SITE = 'location_current_site';

    let openPopup = () => {
      $.fancybox.open({
        src: '#location-popup',
        type: 'inline',
        opts: {
          buttons: [
            'close'
          ],
          modal: true,
          afterShow(inst, current) {
            console.info('done!');
          }
        }
      });
    }

    let isSessionCurrentSite = sessionStorage.getItem(SESSION_KEY_CURRENT_SITE);
    if (!isSessionCurrentSite && triggerOtherSite) {
      if(locaPop == null) {
      openPopup();
      }
    }

    document.querySelectorAll('.location-popup [data-current-site]').forEach(($link) => {
      $link.addEventListener('click', (e) => {
        e.preventDefault();
        $.fancybox.close();
        sessionStorage.setItem(SESSION_KEY_CURRENT_SITE, 'true');
      });
    });
  }

  const TopBarRedirects = () => {
    document.querySelectorAll('[data-trigger-dropdown]').forEach(($item) => {
      $item.addEventListener('click', (e) => {
        console.log(e);
        e.preventDefault();
        $item.classList.toggle('open');
      });
    });
  }

  const CartEmptySwiper = () => {
    let SwipersInit = () => {
      document.querySelectorAll('.empty-cart-swiper:not(.swiper-initialized)').forEach(($section) => {
        var swiper = new Swiper($section, {
          slidesPerView: 1.75,
          spaceBetween: 10,
          centeredSlides: true,
          centeredSlidesBounds: true,
          autoHeight: false,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
          },
          pagination: {
          }
        });      
      });  
    }

    $(document).on('cart-updated', () => {
      setTimeout(SwipersInit, 0);
    });

    var shopify_events = ['shopify:section:deselect','shopify:section:unload'];
    shopify_events.forEach((event_type) => {
      document.addEventListener(event_type, SwipersInit);
    });
  }

  const KlaviyoBIS = () => {
    let isProductPage = window.location.pathname.indexOf('/products/') !== -1;
    if (!isProductPage) return;

    let $forms = document.querySelectorAll('.product_form_options form');
    
    if (isProductPage) {
      let $form_1 = $forms[0];
      let $form_2 = $forms[1];

      if ($form_1) {
        // select 2nd form variant asap to trigger klaviyo variant change
        $form_1.addEventListener('click', () => {
          let selected = $form_1.querySelector('select[name=id]').value;
          if ($form_2) {
            $form_2.querySelector('select[name=id]').value = selected;
          }
        });
      }

      OnElementLoad('.klaviyo-bis-trigger', ($elements) => {
        let $btn = $elements[0];
        if ($form_2) {
          $form_2.querySelector('.add_to_cart').insertAdjacentElement('beforebegin', $btn);
        }
      });
    }
  }

  const DOMReady = () => {
    TextWithColumnImagesSwiper();
    TextReadMoreLess();
    ListReadMoreLess();
    ProductVariantChange();
    ToggleAfterpayWithSubscription();
    LocationPopup();
    TopBarRedirects();
    CartEmptySwiper();
    KlaviyoBIS();
  }

  document.addEventListener('DOMContentLoaded', DOMReady);
})();